import React from 'react';
import { Badge } from './ui/Badge';
import { OrderStatus } from '../types';
export interface StatusBadgeProps {
  status: OrderStatus;
}
export function StatusBadge({
  status
}: StatusBadgeProps) {
  const statusConfig = {
    ordered: {
      label: 'Ordered',
      variant: 'blue' as const
    },
    pending: {
      label: 'Pending',
      variant: 'yellow' as const
    },
    received: {
      label: 'Received',
      variant: 'purple' as const
    },
    reviewed: {
      label: 'Reviewed',
      variant: 'orange' as const
    },
    complete: {
      label: 'Complete',
      variant: 'green' as const
    }
  };
  const config = statusConfig[status];
  return <Badge variant={config.variant} data-id="element-346">{config.label}</Badge>;
}